var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4D55",
    d: "M16.513 1.667h-2.347v-.398c0-.7-.569-1.269-1.269-1.269H7.102c-.7 0-1.269.57-1.269 1.27v.397H3.487c-1.004 0-1.82.816-1.82 1.82v14.692c0 1.004.816 1.821 1.82 1.821h13.026c1.003 0 1.82-.817 1.82-1.82V3.486c0-1.004-.816-1.82-1.82-1.82Zm-9.013 0h5v1.666h-5V1.667Zm7.353 9.614-.034.05c-1.265 1.829-2.983 2.836-4.836 2.836-1.854 0-3.57-1.007-4.835-2.835a.833.833 0 0 1 0-.946C6.446 8.506 8.162 7.5 10.017 7.5c1.853 0 3.57 1.007 4.834 2.834a.834.834 0 0 1 .001.947Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4D55",
    d: "M10.018 9.167c-1.149 0-2.25.595-3.143 1.687.887 1.066 1.974 1.646 3.107 1.646 1.149 0 2.25-.595 3.143-1.688-.887-1.065-1.974-1.645-3.107-1.645Zm-.018 2.5a.834.834 0 1 1 0-1.668.834.834 0 0 1 0 1.668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAnalysis);
export default __webpack_public_path__ + "static/media/view-analysis.5786b568d6eb965261c5e3ad6049611b.svg";
export { ForwardRef as ReactComponent };